export default __webpack_public_path__ + "static/media/Arrow_Right.3dc1bb14.svg";